import { FC } from "react";
import BuyJourneyNamePopup from "../BuyJourneyNamePopup/BuyJourneyNamePopup";
import DownloadQrCodePopup from "../DownloadQrCodePopup/DownloadQrCodePopup";
import LeadIntentConfirmationPopup from "../LeadIntent/LeadIntentConfirmationPopup";
import LeadIntentPopup from "../LeadIntent/LeadIntentPopup";
import CustomLoader from "../../../../features/Feature_GeneralAppElements/AppSwitchHeader/CustomLoader";

interface Props {
  qrCode: any;
  leadIntent: any;
  buyJourney: any;
  leadIntentConfirmation: any;
  isLoading: boolean;
}

const LeadPopups: FC<Props> = ({
  qrCode,
  leadIntent,
  buyJourney,
  leadIntentConfirmation,
  isLoading = false,
}) => {
  return (
    <>
      {qrCode.isOpen && <DownloadQrCodePopup {...qrCode.props} />}
      {buyJourney.isOpen && <BuyJourneyNamePopup {...buyJourney.props} />}
      {leadIntent.isOpen && <LeadIntentPopup {...leadIntent.props} />}
      {leadIntentConfirmation.isOpen && (
        <LeadIntentConfirmationPopup {...leadIntentConfirmation.props} />
      )}
      {isLoading && <CustomLoader />}
    </>
  );
};

export default LeadPopups;
